import useAuthenticate from '../../components/authentication/authenticate';
import MAnnouncements from './MAnnouncements';
import RAnnouncements from './RAnnouncements';

const Announcements = () => {
  const { user, isLoading } = useAuthenticate();

  if (isLoading) return <div>Loading...</div>;

  const role = Object.keys(user?.user?.active || {})[0]; // 'manager', 'owner', 'tenant', etc.

  if (role === 'manager') {
    return <MAnnouncements />;
  } else if (role === 'owner' || role === 'tenant') {
    return <RAnnouncements />;
  }
};

export default Announcements;
